module.exports = __webpack_public_path__ + "static/media/gameJam.03dd0d2e.png";